<template>
  <component :is="tag" :style="badgeStyle"
    ><slot>{{ label }}</slot></component
  >
</template>

<script>
import { getPriorityMetaByRange, getPriorityMetaByValue } from '@/helpers/priorityLevels';

export default {
  name: 'PriorityBadge',
  props: {
    priority: {
      type: [Number, String],
      required: false,
      default: null
    },
    priorityFrom: {
      type: [Number, String],
      required: false,
      default: null
    },
    priorityTo: {
      type: [Number, String],
      required: false,
      default: null
    },
    withBackground: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: 'span'
    }
  },
  computed: {
    meta() {
      if (this.priority !== null && this.priority !== undefined && this.priority !== '') {
        return getPriorityMetaByValue(this.priority);
      }
      return getPriorityMetaByRange(this.priorityFrom, this.priorityTo);
    },
    label() {
      return this.meta ? this.meta.label : '-';
    },
    badgeStyle() {
      if (!this.withBackground || !this.meta) return {};
      return {
        backgroundColor: this.meta.bgColor,
        borderRadius: '6px',
        padding: '0.5rem 0.75rem',
        display: 'inline-block'
      };
    }
  }
};
</script>
